import React from 'react';

export interface IEnvelopeCheckProps {
  className?: string;
  height?: string;
  width?: string;
  viewBox?: string;
}

export default function EnvelopeCheck({ className, height = '40', width = '40', viewBox = '0 0 40 40' }: IEnvelopeCheckProps) {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M5 5C2.23858 5 0 7.23858 0 10V30L6.45965e-05 30.0257C0.0139 32.7753 2.24715 35 5 35H18.75C19.4404 35 20 34.4404 20 33.75C20 33.0596 19.4404 32.5 18.75 32.5H5C3.84287 32.5 2.86936 31.7139 2.58441 30.6465L16.6854 21.969L20 23.9577L37.5 13.4577V21.25C37.5 21.9404 38.0596 22.5 38.75 22.5C39.4404 22.5 40 21.9404 40 21.25V10C40 7.23858 37.7614 5 35 5H5ZM14.2702 20.5199L2.5 27.763V13.4577L14.2702 20.5199ZM2.5 10.5423V10C2.5 8.61929 3.61929 7.5 5 7.5H35C36.3807 7.5 37.5 8.61929 37.5 10V10.5423L20 21.0423L2.5 10.5423Z"
        fill="#04AA6D"
      />
      <path
        d="M40 31.25C40 36.0825 36.0825 40 31.25 40C26.4175 40 22.5 36.0825 22.5 31.25C22.5 26.4175 26.4175 22.5 31.25 22.5C36.0825 22.5 40 26.4175 40 31.25ZM35.0181 27.0531C34.4261 26.6979 33.6583 26.8899 33.3031 27.4819L30.3768 32.3591L29.0089 30.9911C28.5207 30.503 27.7293 30.503 27.2411 30.9911C26.753 31.4793 26.753 32.2707 27.2411 32.7589L29.1751 34.6929C30.0376 35.5554 31.4811 35.3777 32.1087 34.3317L35.4469 28.7681C35.8021 28.1761 35.6101 27.4083 35.0181 27.0531Z"
        fill="#04AA6D"
      />
    </svg>
  );
}
